import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import AddTransferTemplatePage, { getDefaultData, getDefaultUI } from "components/pages/AddTransferTemplatePage";
import Classes from "model";

/**
 * @name CaptureAddTemplateMainToDDOpen
 * @returns {React.Component}
 * @description 
 * This capture is used in the following capture groups:
 * "Transfer Templates" (abi22).
 */
export default function CaptureAddTemplateMainToDDOpen(props) {
    // Initialize all the model classes
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update([ "template", "name" ], "Sample")
    .update([ "template", "fromAccount" ], "6")
    .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultUI())
    .update([ "to", "isActive" ], true)
    .submit();

    return <AddTransferTemplatePage data={ data } ui={ ui } />
}